import React from 'react';
import FormSelect from 'components/FormFields/FormSelect';
import clsx from 'clsx';
import dayjs from 'dayjs';

const EventProject = ({ projectId, setProjectId, projects, isValid, setProjectChanged }) => {
  return (
    <FormSelect
      name="project"
      emptyValue='Select Project…'
      value={projectId}
      className={clsx(!isValid && !projectId && 'error empty')}
      onChange={(e) => {
        setProjectId(e.target.value);
        setProjectChanged(true);
      }}
      required
    >
      {projects.sort((a, b) => a.name.localeCompare(b.name)).map((project) => {
        const formattedProjectDate = dayjs(project.weddingDate).format('MMM D, YYYY');
        return (
          <option
            key={`option-${project.id}`}
            value={project.id}
          >
            { project.name } | { formattedProjectDate }
          </option>
        );
      })}
    </FormSelect>
  );
};

export default EventProject;
